export const BASE_URL = "https://api.uat.roi-ace.leveldata.com/api/";
export const HOST = "https://uat.roi.leveldata.com/";
